// notes.ts - Modern Notion/Linear style notes workspace logic
document.addEventListener('DOMContentLoaded', () => {
    let currentNotes: any[] = [];
    let activeNoteId: any = null;
    let searchQuery: string = '';

    const listEl = document.getElementById('notes-list');
    const editorInnerEl = document.getElementById('notes-editor-inner') as HTMLElement | null;
    const emptyStateEl = document.getElementById('notes-empty-state') as HTMLElement | null;
    const titleEl = document.getElementById('note-title') as HTMLInputElement | null;
    const contentEl = document.getElementById('note-content') as HTMLTextAreaElement | null;
    const saveBtn = document.getElementById('save-note-btn');
    const deleteBtn = document.getElementById('delete-note-btn');
    const newBtn = document.getElementById('new-note-btn');
    const emptyNewBtn = document.getElementById('empty-new-note-btn');
    const headerAddBtn = document.getElementById('notes-add-btn');
    const searchInput = document.getElementById('notes-search-input') as HTMLInputElement | null;
    const saveStatusEl = document.getElementById('note-save-status');

    (window as any).loadNotes = loadNotes;

    async function loadNotes() {
        try {
            const res = await fetch('api/notes.php?action=list');
            const data = await res.json();
            if (data.success) {
                currentNotes = data.data;
                renderNotesList();

                if (currentNotes.length === 0) {
                    showEmptyState();
                } else if (!activeNoteId) {
                    openNote(currentNotes[0]);
                } else {
                    const found = currentNotes.find(n => Number(n.id) === Number(activeNoteId));
                    if (found) {
                        openNote(found);
                    } else {
                        openNote(currentNotes[0]);
                    }
                }
            }
        } catch (e) {
            console.error('Failed to load notes', e);
        }
    }

    function renderNotesList() {
        if (!listEl) return;
        listEl.innerHTML = '';

        const filtered = currentNotes.filter(note => {
            if (!searchQuery.trim()) return true;
            const q = searchQuery.toLowerCase();
            const title = (note.title || '').toLowerCase();
            const content = (note.content || '').toLowerCase();
            return title.includes(q) || content.includes(q);
        });

        if (filtered.length === 0) {
            const emptyItem = document.createElement('li');
            emptyItem.style.padding = '16px 12px';
            emptyItem.style.textAlign = 'center';
            emptyItem.style.fontSize = '12px';
            emptyItem.style.color = 'var(--text-dim)';
            emptyItem.innerText = searchQuery ? 'Нічого не знайдено' : 'Немає нотаток';
            listEl.appendChild(emptyItem);
            return;
        }

        filtered.forEach(note => {
            const li = document.createElement('li');
            li.className = 'note-list-item' + (Number(activeNoteId) === Number(note.id) ? ' active' : '');
            
            const titleDiv = document.createElement('div');
            titleDiv.className = 'note-item-title';
            titleDiv.innerHTML = `<i class="ri-file-text-line"></i> <span>${escapeHtml(note.title || 'Без назви')}</span>`;
            
            const snippetDiv = document.createElement('div');
            snippetDiv.className = 'note-item-snippet';
            const cleanContent = (note.content || '').replace(/[#*`_~-]/g, '').trim();
            snippetDiv.innerText = cleanContent.slice(0, 45) || 'Порожня нотатка...';

            li.appendChild(titleDiv);
            li.appendChild(snippetDiv);
            li.onclick = () => openNote(note);
            listEl.appendChild(li);
        });
    }

    function showEmptyState() {
        activeNoteId = null;
        if (editorInnerEl) editorInnerEl.style.display = 'none';
        if (emptyStateEl) emptyStateEl.style.display = 'flex';
    }

    function openNote(note: any) {
        if (!note) {
            showEmptyState();
            return;
        }
        activeNoteId = note.id;
        if (emptyStateEl) emptyStateEl.style.display = 'none';
        if (editorInnerEl) editorInnerEl.style.display = 'flex';
        
        if (titleEl) titleEl.value = note.title || '';
        if (contentEl) contentEl.value = note.content || '';
        
        if (saveStatusEl) {
            saveStatusEl.innerHTML = '<i class="ri-checkbox-circle-line"></i> Збережено';
            saveStatusEl.style.color = '#10b981';
        }

        renderNotesList();
    }

    function markUnsaved() {
        if (saveStatusEl) {
            saveStatusEl.innerHTML = '<i class="ri-edit-line"></i> Є незбережені зміни';
            saveStatusEl.style.color = '#f59e0b';
        }
    }

    if (titleEl) titleEl.addEventListener('input', markUnsaved);
    if (contentEl) contentEl.addEventListener('input', markUnsaved);

    async function createNewNote() {
        try {
            const res = await fetch('api/notes.php?action=create', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ title: 'Нова нотатка', content: '' })
            });
            const data = await res.json();
            if (data.success) {
                await loadNotes();
                const newNote = currentNotes.find(n => Number(n.id) === Number(data.id));
                if (newNote) {
                    openNote(newNote);
                    if (titleEl) {
                        titleEl.focus();
                        titleEl.select();
                    }
                }
            }
        } catch (e) {
            console.error('Create note failed', e);
        }
    }

    async function saveCurrentNote() {
        if (!activeNoteId) return;
        try {
            if (saveStatusEl) {
                saveStatusEl.innerHTML = '<i class="ri-loader-4-line ri-spin"></i> Збереження...';
                saveStatusEl.style.color = 'var(--text-dim)';
            }
            const res = await fetch('api/notes.php?action=update', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: activeNoteId,
                    title: titleEl ? titleEl.value : '',
                    content: contentEl ? contentEl.value : ''
                })
            });
            const data = await res.json();
            if (data.success) {
                if (saveStatusEl) {
                    saveStatusEl.innerHTML = '<i class="ri-checkbox-circle-line"></i> Збережено';
                    saveStatusEl.style.color = '#10b981';
                }
                const activeNote = currentNotes.find(n => Number(n.id) === Number(activeNoteId));
                if (activeNote) {
                    activeNote.title = titleEl ? titleEl.value : '';
                    activeNote.content = contentEl ? contentEl.value : '';
                    renderNotesList();
                }
            }
        } catch (e) {
            console.error('Save note failed', e);
            if (saveStatusEl) {
                saveStatusEl.innerHTML = '<i class="ri-error-warning-line"></i> Помилка';
                saveStatusEl.style.color = '#ef4444';
            }
        }
    }

    if (newBtn) newBtn.onclick = createNewNote;
    if (emptyNewBtn) emptyNewBtn.onclick = createNewNote;
    if (headerAddBtn) headerAddBtn.onclick = createNewNote;

    if (saveBtn) saveBtn.onclick = saveCurrentNote;

    if (deleteBtn) {
        deleteBtn.onclick = async () => {
            if (!activeNoteId) return;
            if (!confirm('Видалити цю нотатку?')) return;
            try {
                const res = await fetch('api/notes.php?action=delete&id=' + activeNoteId);
                const data = await res.json();
                if (data.success) {
                    if ((window as any).showMessage) (window as any).showMessage('Нотатку видалено', 'success');
                    activeNoteId = null;
                    await loadNotes();
                }
            } catch (e) {
                console.error('Delete note failed', e);
            }
        };
    }

    if (searchInput) {
        searchInput.addEventListener('input', (e: any) => {
            searchQuery = e.target.value || '';
            renderNotesList();
        });
    }

    // Keyboard shortcut Ctrl+S / Cmd+S
    document.addEventListener('keydown', (e) => {
        if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 's') {
            const notesPanel = document.getElementById('notes');
            if (notesPanel && notesPanel.classList.contains('active')) {
                e.preventDefault();
                saveCurrentNote();
            }
        }
    });

    function escapeHtml(str: string) {
        return str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    const notesTabBtn = document.querySelector('button[data-tab="notes"]');
    if (notesTabBtn) {
        notesTabBtn.addEventListener('click', () => {
            loadNotes();
        });
    }

    loadNotes();
});
